export default "__VITE_ASSET__DEzxd2yJ__"